import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { useAppliedTheme } from '@xing-com/hub';
import { IllustrationStickerMegaphone } from '@xing-com/illustrations';
import {
  zIndexSticky,
  mediaConfined,
  mediaXWide,
} from '@xing-com/layout-tokens';
import { Link } from '@xing-com/link';
import { DarkMode, LightMode } from '@xing-com/theme-mode-switcher';
import {
  spaceL,
  spaceS,
  spaceXS,
  spaceXL,
  spaceXXL,
  xdlColorTextOnLight,
  xdlColorControlFillInvert,
  xdlColorTextInvert,
  cornerRadiusXL,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Teaser: React.FC = () => {
  return (
    <StyledBodyCopy noMargin>
      <FormattedMessage
        id="JOBS_FIND_JOBS_RECRUITERS_LINK"
        values={{
          a: (chunks) => (
            <RecruitersLink to="/recruiting/jobs/create?sc_cmp=oowecdf8a53">
              {chunks}
            </RecruitersLink>
          ),
        }}
      />
    </StyledBodyCopy>
  );
};

export const TeaserOnSide: React.FC = () => {
  const appliedTheme = useAppliedTheme();
  const Theme = appliedTheme === 'dark' ? LightMode : DarkMode;

  return (
    <OnSideContainer>
      <Theme>
        <IllustrationStickerMegaphone size="small" />
      </Theme>
      <OnSideTextContainer>
        <OnSideHeaderText size="small">
          <FormattedMessage
            id="JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE"
            defaultMessage="JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE"
          />
        </OnSideHeaderText>
        <OnSideBodyText
          size="small"
          href="/recruiting/jobs/create?sc_cmp=oow358a447d"
        >
          <FormattedMessage
            id="JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE"
            defaultMessage="JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE"
          />
        </OnSideBodyText>
      </OnSideTextContainer>
    </OnSideContainer>
  );
};

const StyledBodyCopy = styled(BodyCopy)`
  display: none;
  text-align: center;
  color: ${xdlColorTextOnLight};

  @media ${mediaConfined} {
    display: block;
    padding-top: ${spaceXL};
  }
`;

const RecruitersLink = styled(Link)`
  color: ${xdlColorTextOnLight};
  font-weight: 700;
`;

const OnSideContainer = styled.div`
  display: none;
  position: absolute;
  top: ${spaceXXL};
  left: 0;
  z-index: ${zIndexSticky};
  background-color: ${xdlColorControlFillInvert};
  padding: ${spaceL};
  border-top-right-radius: ${cornerRadiusXL};
  border-bottom-right-radius: ${cornerRadiusXL};

  & > * {
    display: flex;
  }

  @media ${mediaXWide} {
    display: flex;
  }
`;

const OnSideTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${spaceS};
`;

const OnSideHeaderText = styled(BodyCopy)`
  margin-bottom: ${spaceXS};
  color: ${xdlColorTextInvert};
`;

const OnSideBodyText = styled(TextButton)`
  height: 17px;
  color: ${xdlColorTextInvert};

  &:visited {
    color: ${xdlColorTextInvert};
  }
  &:focus {
    outline: 2px solid ${xdlColorTextInvert};
  }
`;
